module.exports = __webpack_public_path__ + "static/media/thumbsdown.aa266301.svg";